import { useSelector } from 'react-redux';
import { investmentsSelector } from 'apps/investor/resources/investments/selectors';

export function useInvestorHasInvestmentsSelector() {
  return useSelector(investmentsSelector);
}
